import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';
import { queryClient } from '@/shared/query-client/query-client';

import { UseFetchEnabledParams, UseMutationsParams,  SolicitudCorporativa, SolicitudCorporativaPaginRes } from "@/shared/interfaces";
import { ForumularioSolicitudCoorporativo } from "@/shared/interfaces/erp/corporativa/solicitudCorporativa.interface";
import { getUrlParamsFetch } from '@/shared/utils';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery} from '@tanstack/react-query';

import { toast } from "react-toastify";
import { toApiError } from "@/shared/utils/general";
const { get, post, put } = erpApi(); 

export interface SolicitudPreventa {
        nombre_sucursal: string;
        velocidad_kbps: number;
        servicio: string;
        coordenadas: string;
        estado:boolean,
        comentarios_permisos: string;
}
export type SaveSolicitudInterface = {
    titlePage: string;
    solicitudEditar?: SolicitudPreventa;
};

// Definimos la estructura de los datos del formulario
export type SaveFormData = {
    sucursales: {
        nombre_sucursal: string;
        velocidad_kbps: number;
        servicio: string;
        coordenadas: string;
    }[];
};


/**metodo patch */
export interface IUpdateSolicitudComentariosPayload {
  comentario_general?: string;
  estado_solicitud?: string;
  complejidad?: string;
  clientes?: {
    id_solicitud_cliente: string;
    sucursales?: {
      id_solicitud_sucursal: string;
      comentario: string;
    }[];
  }[];
}

/***get usuario */

export interface SolicitudPreventaRow {
  id_solicitud: string;
  codigo: string;               // código único EXT-RQ-000001
  nombre_cliente: string;
  nombre_sucursal: string;      // nombres concatenados
  velocidad_kbps: string;       // opcionalmente promedio o primera
  servicio: string;             // concatenado
  coordenadas: string;           // concatenado
  comentarios_permisos: string; // comentario_general
  estado_solicitud: string;
  complejidad: string;
  fecha_creacion: string;       // fecha de registro
  fecha_gestion: string;        // fecha de aprobación / gestión
}

/**GET GENERAL TODAS LAS SOLICITUDES*/
export const useFetchgetSolicitudesTotales = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GetSolicitudParams> = {}) => {
  return useQuery({
    queryKey: ['solicitud', params],
    queryFn: () => getSolicitudesTotales(params),
    enabled: enabled,
    refetchOnWindowFocus: false,
  });
};

export const getSolicitudesTotales = async (
  params?: GetSolicitudParams
) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<SolicitudCorporativaPaginRes>(`${urlBackend}api/v1/solicitud/?${queryParams}`, true);
};
/** */




//get individual

export const usegetsolicitudcorporativa = (id: string) => {
  return useQuery({
    queryKey: ['solicitudcorporativa', id],
    queryFn: async () => {
      return getSolicitudCorporativa(id);
    },
  });
};
//get individual 
export const getSolicitudCorporativa = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;
  const res = await get<SolicitudCorporativa>(`${urlBackend}api/v1/solicitud-individual/${id}/`, true);

  res.status === 'error' && setAlert(true, res.message, res.status);
  return res;
};


///CREATE

export const usePostSolicitudCorporativa = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: (data: ForumularioSolicitudCoorporativo) => {
      return postSolicitudCorporativa(data);
    },

    onSuccess: (data) => {
      // Refresca ambas tablas: "mis solicitudes" (/solicitud) y el listado
      // total (/solicitud/solicitud-verificacion).
      queryClient.invalidateQueries({ queryKey: ['mis-solicitudes'] });
      queryClient.invalidateQueries({ queryKey: ['solicitud'] });

      navigate && returnUrl && navigate(returnUrl);

      toast.success(data.message);
    },

    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    }
  });
};

export const postSolicitudCorporativa = async (
  data: ForumularioSolicitudCoorporativo
) => {
  return await post(
    `${urlBackend}api/v1/solicitud/`,
    data,
    true
  );
};

///PUT INDIVIDUAL

export const usePutSolicitudCorporativa = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {

  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: IUpdateSolicitudComentariosPayload }) =>
      putSolicitudCorporativa(id, data),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['mis-solicitudes'] });
      queryClient.invalidateQueries({ queryKey: ['solicitud'] });
      toast.success("Solicitud actualizada correctamente");
      navigate && returnUrl && navigate(returnUrl);
    },

    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    }
  });
};

export const putSolicitudCorporativa = async (
  id: string,
  data: IUpdateSolicitudComentariosPayload
) => {
  return await put(
    `${urlBackend}api/v1/solicitud-individual/${id}/`,
    data,
    true
  );
};


////get para usuario

export const useFetchMisSolicitudes = ({
  enabled = true,
  params,
}: UseFetchEnabledParams<GetSolicitudParams> = {}) => {
  return useQuery({
    queryKey: ['mis-solicitudes', params],
    queryFn: async () => getMisSolicitudes(params),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getMisSolicitudes = async (params?: GetSolicitudParams ) => {
  const queryParams = getUrlParamsFetch(params ?? {});
  return get<SolicitudCorporativaPaginRes>(
    `${urlBackend}api/v1/solicitudusuario/?${queryParams}`,
    true
  );
};

export type GetSolicitudParams = Partial<SolicitudPreventaRow> & {
  page?: number;
  page_size?: number;
  filterByState?: boolean;
  search?:string;
};

